import { VoladeumResponse } from 'client/types';

import { Axios } from '../../axios';

import { UserCreate } from './types';

export class VoladeumUsers extends Axios {
  async create(payload: UserCreate): Promise<VoladeumResponse<string>> {
    return this.post<VoladeumResponse<string>>('/v1/users', payload);
  }
}
